import { Trackable } from '@shared/utils';

export interface JobBoard extends Trackable {
  canonicalName: string;
  createdById: string;
  createdByName: string;
  createdDate: string;
  headerImageId: number;
  headerText: string;
  jobBoardName: string;
  lastModifiedById: string;
  lastModifiedByName: string;
  referralProgram: boolean;
  siteLogoId: number;
  status: boolean;
  standard: boolean;
  subheaderText: string;
  jobPostsTotal?: number;
  isPublished?: boolean;
  jobBoardPostId?: number;
  headerOverlayStyle: string;
}

export interface HeaderOverlayStyle {
  overlayBackgroundColor: string;
  overlayOpacity: number;
}

export const DEFAULT_HEADER_BACKGROUD_COLOR = '#cacaca';

export const DEFAULT_HEADER_BACKGROUD_OPACITY = 100;
